// extracted by css-extract-rspack-plugin
export default {"cls1":"AppsMegaMenu-cls1_Psz","cls2":"AppsMegaMenu-cls2_meR AppsMegaMenu-cls1_Psz"};